<div id="video-cooperation" [ngClass]="{'pcVideo':isPC}"  [@videoAnimation] *ngIf="showVideo">

</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-video/case-practice-cooperation-video.component.html